import { createSelector } from "reselect";
const selector = (state) => state.productHistory;

export default createSelector([selector], (data) => data);